import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SharedPipesModule } from '@fantaz/shared/pipes';
import { SharedUiVideoPlayerModule } from '@fantaz/shared/ui/video-player';
import { ShareDialogComponent } from './share-dialog.component';
import { ShareComponent } from './share.component';

import { SharedUiCopyLinkModule } from '@fantaz/shared/ui/copy-link';
import { MaterialModule } from '@fantaz/shared/ui/material';
@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    SharedPipesModule,
    MatSnackBarModule,
    SharedUiVideoPlayerModule,
    SharedUiCopyLinkModule,
  ],
  declarations: [ShareComponent, ShareDialogComponent],
  exports: [ShareComponent],
})
export class ShareModule {}
